import { api, FormatResponse } from '../index';
const BASE_ENDPOINT ='/api/v1/workflows/create-wc-webhook';

export const createWoocommerceWebHook= async (workflowId) => {
        const webhookRes = await api.patch(`${BASE_ENDPOINT}/${workflowId}`);
        return new FormatResponse(webhookRes);
};